/**
 * M.A.A.P. progressbar constructor.
 */
export class Progressbar {
    /**
     * Create a new Progressbar instance.
     * @param containerEl - Container element to attach progressbar to.
     */
    constructor(containerEl) {
        /**
         * The progressbar's state object.
         */
        this.state = {
            isLoading: false,
            width: 0,
            intervalFn: null,
        };
        this.containerEl = containerEl;
        this.progressbarEl = this.createProgressbarEl();
        containerEl.appendChild(this.progressbarEl);
    }
    /**
     * Start the progressbar animation.
     */
    start() {
        if (this.state.isLoading)
            return;
        this.state.isLoading = true;
        const increaseWidthBy = 100 * (Progressbar.interval / Progressbar.timeout);
        this.state.width += increaseWidthBy;
        this.updateDOM();
        this.state.intervalFn = window.setInterval(() => {
            if (this.state.width >= 100) {
                this.stop();
                return;
            }
            this.state.width += increaseWidthBy;
            this.updateDOM();
        }, Progressbar.interval);
    }
    /**
     * Stop the progressbar animation.
     */
    stop() {
        if (this.state.intervalFn)
            clearInterval(this.state.intervalFn);
        this.state.isLoading = false;
        this.state.width = 100;
        this.updateDOM();
    }
    /**
     * Get the progressbar's width state.
     * @returns The progressbar's width state.
     */
    getWidth() {
        return this.state.width;
    }
    /**
     * Update the DOM elements.
     */
    updateDOM() {
        this.updateProgressbarEl();
        this.updateContainerEl();
    }
    /**
     * Update the progressbar element.
     */
    updateProgressbarEl() {
        this.progressbarEl.style.width = `${this.state.width}%`;
        this.progressbarEl.classList.toggle('is-loading', this.state.isLoading);
    }
    /**
     * Update the container element.
     */
    updateContainerEl() {
        this.containerEl.classList.toggle('is-loading', this.state.isLoading);
    }
    /**
     * Create the progressbar element.
     * @returns The newly created progressbar DOM element.
     */
    createProgressbarEl() {
        const progressbarEl = document.createElement('div');
        progressbarEl.classList.add('maap_p-progressbar');
        progressbarEl.setAttribute('data-test-id', 'progressbar');
        return progressbarEl;
    }
}
/**
 * The loading progress interval (in milliseconds).
 */
Progressbar.interval = 0.01 * 1000;
/**
 * The loading timeout interval (in milliseconds).
 */
Progressbar.timeout = 10 * 1000;
//# sourceMappingURL=Progressbar.js.map